import { DEFAULT_THEME_ID } from '../types/theme';

const THEME_ASSET_PATH_RE = /\/themes\/([^/]+)\/([^/.]+)\.[^./]+$/;

export type ThemeAssetRegistry = Record<string, Record<string, string>>;

const themeAssetModules = import.meta.glob<string>('../assets/themes/*/*', {
  eager: true,
  query: '?url',
  import: 'default',
});

function parseThemeAssetPath(path: string): { themeId: string; assetName: string } | null {
  const normalized = path.replace(/\\/g, '/');
  const match = normalized.match(THEME_ASSET_PATH_RE);
  if (!match) {
    return null;
  }

  return { themeId: match[1], assetName: match[2] };
}

export function buildThemeAssetRegistry(): ThemeAssetRegistry {
  const registry: ThemeAssetRegistry = {};

  for (const [path, url] of Object.entries(themeAssetModules)) {
    const parsed = parseThemeAssetPath(path);
    if (!parsed) {
      continue;
    }

    registry[parsed.themeId] ??= {};
    registry[parsed.themeId][parsed.assetName] = url;
  }

  return registry;
}

export const THEME_ASSET_REGISTRY = buildThemeAssetRegistry();

export const THEME_ASSET_NAMES = Object.keys(THEME_ASSET_REGISTRY[DEFAULT_THEME_ID] ?? {});
